module.exports = __webpack_public_path__ + "a97f702995d05830d8ab2dbff9a8d12f.png";